// Import FilePond
import vueFilePond from 'vue-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size'

const FilePond = vueFilePond( FilePondPluginFileValidateType, FilePondPluginImagePreview, FilePondPluginFileValidateSize );

export const FilepondService = {

	/*
	**  Set the methods
	*/

	methods: {

		handleFilePondError: function(error, file) {

			// Fire error message
			this.$swal('Uh Oh!', 'Looks like there was a problem processing your upload.', 'error');

		},

		load: function(source, load, error, progress, abort, headers) {

			progress(true, progressCallback, 100);

		},

		process: function(fieldName, file, metadata, load, error, progress, abort) {

			// Process the file upload
			this.processFileUpload(file, load);

		}

	}

}